import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { UPDATE_AIRPORT_V2, UPDATE_AIRPORT_V2_SUCCESS, UPDATE_AIRPORT_V2_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* updateAirportV2({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/benefit-type/airport-transfer/airports`,
      method: 'PUT',
      data: payload?.data,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: UPDATE_AIRPORT_V2_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: UPDATE_AIRPORT_V2_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: UPDATE_AIRPORT_V2_ERROR, payload: error });
  }
}

export function* watchupdateAirportV2() {
  yield takeEvery(UPDATE_AIRPORT_V2, updateAirportV2);
}

function* updateAirportV2Saga() {
  yield all([fork(watchupdateAirportV2)]);
}

export default updateAirportV2Saga;
